import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const situations = ['Evitas iniciar relaciones por miedo a fallar.', 'Piensas demasiado cuando llega el momento.', 'Tu confianza ya no es la misma.', 'Te preocupa que vuelva a pasar.', 'Terminas antes de lo que quisieras.'];
  return <section className="relative w-full bg-[#0a0a0a] py-12 md:py-16 overflow-hidden" data-id="element-389">
      <div className="absolute inset-0 z-0" data-id="element-390">
        <div className="absolute top-1/2 -left-1/4 w-[500px] h-[500px] rounded-full bg-red-800/10 blur-[120px]" data-id="element-391" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-black to-transparent z-10" data-id="element-392" />
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black to-transparent z-10" data-id="element-393" />

      <div className="relative z-20 max-w-3xl mx-auto px-6" data-id="element-394">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-395">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-396">
            <div className="w-12 h-px bg-red-900/50" data-id="element-397" />
            <span className="text-gray-400 text-xs uppercase tracking-[0.3em] font-medium" data-id="element-398">
              La Realidad
            </span>
            <div className="w-12 h-px bg-red-900/50" data-id="element-399" />
          </div>

          <h2 className="font-display text-3xl md:text-5xl uppercase mb-10 text-center text-white drop-shadow-[0_0_15px_rgba(255,255,255,0.1)]" data-id="element-400">
            Sabemos cómo se siente
          </h2>

          <div className="bg-gradient-to-b from-[#0a0a0a] to-black border border-red-900/30 rounded-2xl p-6 md:p-10 shadow-[0_0_30px_rgba(220,38,38,0.05)]" data-id="element-401">
            <div className="space-y-4" data-id="element-402">
              {situations.map((situation, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.5
            }} className="flex items-start gap-4" data-id="element-403">
                  <div className="mt-1 flex-shrink-0 w-1.5 h-1.5 rounded-full bg-red-500 shadow-[0_0_8px_rgba(220,38,38,0.8)]" data-id="element-404" />
                  <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-405">
                    {situation}
                  </p>
                </motion.div>)}
            </div>

            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.6,
            duration: 0.6
          }} className="mt-8 pt-6 border-t border-red-900/20" data-id="element-406">
              <p className="text-lg md:text-xl text-center text-gray-400 italic" data-id="element-407">
                No es tu culpa, pero{' '}
                <span className="text-white font-semibold not-italic" data-id="element-408">
                  sí tiene solución.
                </span>
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}